import { createSlice } from '@reduxjs/toolkit';

// Initial state for service slice
export const initialState = {
  data: '',
  loading: false,
};

const thirdPartyLogisticsSlice = createSlice({
  name: 'thirdPartyLogistics',
  initialState,
  reducers: {
    // Action to create a service
    createThirdPartyLogistics: (state, action) => {
      state.data = action.payload;
    },
    // Action to set loading state
    setLoading: (state) => {
      state.loading = true;
    },
    // Action to reset loading and error states
    resetLoadingAndError: (state) => {
      state.loading = false;
    },
  },
});

export const ThirdPartyLogisticsActions = thirdPartyLogisticsSlice.actions;
export const ThirdPartyLogisticsReducer = thirdPartyLogisticsSlice.reducer;

export const thirdPartyLogisticsTypes = {
  CREATE_THIRD_PARTY_LOGISTICS:
    'thirdPartyLogistics/CREATE_THIRD_PARTY_LOGISTICS',
};
